import React from 'react';
import { usePermissions } from '../hooks/usePermissions';
import { AdminPermission } from '../generated/graphql';

interface PermissionGuardProps {
  permission: AdminPermission;
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

export const PermissionGuard: React.FC<PermissionGuardProps> = ({ 
  permission, 
  children, 
  fallback = null 
}) => {
  const { hasPermission } = usePermissions();
  
  if (hasPermission(permission)) {
    return <>{children}</>;
  }
  
  return <>{fallback}</>;
};

interface RoleGuardProps {
  role: string;
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

export const RoleGuard: React.FC<RoleGuardProps> = ({ 
  role, 
  children, 
  fallback = null 
}) => {
  const { hasRole } = usePermissions();
  
  if (hasRole(role as any)) {
    return <>{children}</>;
  }
  
  return <>{fallback}</>;
};

interface SuperAdminGuardProps {
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

export const SuperAdminGuard: React.FC<SuperAdminGuardProps> = ({ 
  children, 
  fallback = null 
}) => {
  const { isSuperAdmin } = usePermissions();
  
  if (isSuperAdmin()) {
    return <>{children}</>;
  }
  
  return <>{fallback}</>;
}; 